/**
 * 인증 관련 쿠키 유틸리티 함수들
 */ /**
 * 인증 관련 쿠키 삭제 헬퍼 함수
 * SameSite와 Secure 속성을 고려한 완전한 쿠키 삭제
 */ export var clearAuthCookies = function() {
    // 인증 관련 쿠키명 - Spring Security와 OAuth2 쿠키 포함
    var authCookieNames = [
        'JSESSIONID',
        'REMEMBER_ME',
        'oauth2_auth_request',
        'oauth2_state',
        'SPRING_SECURITY_REMEMBER_ME_COOKIE',
        'XSRF-TOKEN',
        'CSRF-TOKEN'
    ];
    var authServerDomain = new URL(import.meta.env.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk').hostname;
    var currentDomain = window.location.hostname;
    // 다양한 도메인과 속성 조합으로 쿠키 삭제 시도
    var domains = [
        currentDomain,
        ".".concat(currentDomain),
        authServerDomain,
        ".".concat(authServerDomain),
        'ugot.uk',
        '.ugot.uk'
    ];
    var paths = [
        '/',
        '/oauth2',
        '/login',
        '/logout'
    ];
    authCookieNames.forEach(function(cookieName) {
        domains.forEach(function(domain) {
            paths.forEach(function(path) {
                // 기본 삭제
                document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path, "; domain=").concat(domain);
                // Secure 속성 추가 삭제
                document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path, "; domain=").concat(domain, "; Secure");
                // SameSite=None + Secure 조합 삭제
                document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path, "; domain=").concat(domain, "; SameSite=None; Secure");
                // SameSite=Lax 삭제
                document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path, "; domain=").concat(domain, "; SameSite=Lax");
                // SameSite=Strict 삭제
                document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path, "; domain=").concat(domain, "; SameSite=Strict");
            });
        });
        // 도메인 없이도 삭제 시도
        paths.forEach(function(path) {
            document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=").concat(path);
        });
    });
    // 모든 쿠키 확인 및 강제 삭제
    var allCookies = document.cookie.split(';');
    allCookies.forEach(function(cookie) {
        var cookieName = cookie.split('=')[0].trim();
        if (authCookieNames.some(function(authName) {
            return cookieName.includes(authName) || authName.includes(cookieName);
        })) {
            // 발견된 인증 관련 쿠키 강제 삭제
            document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
            console.log("[AuthUtils] 강제 삭제된 쿠키: ".concat(cookieName));
        }
    });
    console.log('[AuthUtils] 인증 관련 쿠키 완전 삭제 완료');
};
